import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

const FARMER_GROUP_BASE_v1 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.FARMER_GROUP,
  false
);

export const getFarmerGroupReportdata = ({ cursor, limit, tenant, filter }) => {
  const baseURL = apiClient.defaults.baseURL;

  const url = `${FARMER_GROUP_BASE_v1}/report`;
  const fullURL = `${baseURL}/${url}`;

  // Log the full URL to the console
  console.log('Making API call to:', baseURL, fullURL);

  return apiClient.post(url, {
    cursor,
    limit,
    filters: filter
  });
};

export const FarmerGroupApi = {
  // Fetch table data
  getFarmerGroupReportData: (cursor, limit, tenant, filter) =>
    apiClient.post(`${FARMER_GROUP_BASE_v1}/report/`, cursor, limit, filter),

  // Fetch dynamic form for farmer creation
  getCreateFarmerGroupForm: tenantId =>
    apiClient.get(`${FARMER_GROUP_BASE_v1}/form?is_edit=false`),

  sendFarmerGroupCreate: (tns_tenant, data) =>
    apiClient.post(`${FARMER_GROUP_BASE_v1}`, data),

  populateFarmerGroupEditForm: (tenantId, FarmerGroupId) =>
    apiClient.get(`${FARMER_GROUP_BASE_v1}/${FarmerGroupId}`),

  updateFarmerGroupForm: (tenantId, groupId, data) =>
    apiClient.put(`${FARMER_GROUP_BASE_v1}/${groupId}`, data),

  getEditFarmerGroupForm: (tenantId, edit, groupId) =>
    apiClient.get(
      `${FARMER_GROUP_BASE_v1}/form?is_edit=${edit}&group_id=${groupId}`
    )
};
